import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login/Login';
import TotpSetup from './components/TotpSetup/TotpSetup';
import TotpVerify from './components/TotpVerify/TotpVerify';
import Dashboard from './components/Dashboard/Dashboard';
import './App.css';

const AppContent = () => {
  const { isAuthenticated, totpState } = useAuth();

  if (isAuthenticated) return <Dashboard />;
  if (totpState?.step === 'setup_totp') return <TotpSetup />;
  if (totpState?.step === 'verify_totp') return <TotpVerify />;
  return <Login />;
};

const App = () => {
  return (
    <AuthProvider>
      <div className="app">
        <AppContent />
      </div>
    </AuthProvider>
  );
};

export default App;
